<template>
<div>
  <div style="height: 40px;margin: 10px 40px">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div v-if="indexActive === 0">
    <all-info :row="row"></all-info>
  </div>
  <div v-if="indexActive === 1">
    <blood-pressure :IDs="IDs" :personRow="oldPersonInfoObj"></blood-pressure>
  </div>
  <div v-if="indexActive === 2">
    <blood-sugar :IDs="IDs" :personRow="oldPersonInfoObj"></blood-sugar>
  </div>
  <div v-if="indexActive === 3">
    <put-up></put-up>
  </div>
  <div v-if="indexActive === 4">
    <look-after :row="row"></look-after>
  </div>
</div>
</template>

<script>
import allInfo from './allInfo'
import bloodPressure from './bloodPressure'
import bloodSugar from './bloodSugar'
import putUp from './putUp'
import lookAfter from './lookAfter'
import {queryhealthdatatype} from '../../../api/yanglaoyuan'

export default {
  name: 'oldPersonInfoList',
  components: {allInfo, bloodPressure, bloodSugar, putUp, lookAfter},
  model: {
    prop: 'oldPersonInfoShow',
    event: 'change'
  },
  props: {
    oldPersonInfoObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '基本信息'},
        {index: 1, name: '血压记录'},
        {index: 2, name: '血糖记录'},
        {index: 3, name: '住宿信息'},
        {index: 4, name: '护理记录'}
      ],
      indexActive: 0,

      row: {},
      IDs: {gaoId: '', diId: '', xuetang: ''}
    }
  },
  created () {
    this.getHealthTypeData()
    this.getStartData()
    console.log(this.row)
  },
  methods: {
    // 健康数据类型
    getHealthTypeData () {
      queryhealthdatatype().then(res => {
        let healthdatatype = res.data.healthdatatype
        healthdatatype.forEach(item => {
          if (item.key_name === '血压-高压') {
            this.IDs.gaoId = item.id
          } else if (item.key_name === '血压-低压') {
            this.IDs.diId = item.id
          } else if (item.key_name === '血糖') {
            this.IDs.xuetang = item.id
          }
        })
      })
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    getStartData () {
      this.row = this.oldPersonInfoObj
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/oldPersonInfoList.vue